import ConvenienceTabButtonListBox from '@/pages/function/components/ConvenienceTabButtonListBox';
import ConvenienceContentListBox from '@/pages/function/components/ConvenienceContentListBox';
import ConvenienceSubContentListBox from '@/pages/function/components/ConvenienceSubContentListBox';
import useScrollReset from '@/hooks/useScrollReset';

const ConvenienceFunctionPage = () => {
	useScrollReset();
	return (
		<>
			<section className="sub-content">
				<div className="cont1">
					<div className="sub-inner">
						<ConvenienceTabButtonListBox />
					</div>
					<ConvenienceContentListBox />
				</div>
				<div className="cont2">
					<div className="sub-inner">
						<ConvenienceSubContentListBox />
					</div>
				</div>
			</section>
		</>
	);
};

export default ConvenienceFunctionPage;
